import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const FormationIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 47 27" {...props}>
    <g id="Formation">
      <rect width="47" height="27" fill="#ffffff00" />
      <path
        id="Tracé_12117"
        data-name="Tracé 12117"
        d="M39.422-39.512v-5.16a.692.692,0,0,0,.064-.26.816.816,0,0,0-.524-.765L17.6-53.68a.833.833,0,0,0-.564,0L-4.848-45.7a.823.823,0,0,0-.545.763.8.8,0,0,0,.546.766L1.3-42.019v9.062a.845.845,0,0,0,.57.779l15.195,4.661a.923.923,0,0,0,.247.042.79.79,0,0,0,.235-.042l14.8-4.661a.806.806,0,0,0,.566-.783v-9.057l4.862-1.728V-39.5a2.118,2.118,0,0,0-1.324,1.955,2.14,2.14,0,0,0,.618,1.526,2.131,2.131,0,0,0,1.515.641H38.6a2.153,2.153,0,0,0,2.15-2.133A2.144,2.144,0,0,0,39.422-39.512Zm-.307,1.954a.494.494,0,0,1-.141.359.5.5,0,0,1-.319.152H38.6a.515.515,0,0,1-.515-.516.516.516,0,0,1,.515-.516A.517.517,0,0,1,39.116-37.558Zm-2.832-7.4-4.446,1.585-14.52,5.547L2.4-43.369l-4.532-1.586,19.449-7.09ZM2.946-41.412,17.03-36.175a.7.7,0,0,0,.3.047,1.126,1.126,0,0,0,.274-.046l13.689-5.219,0,7.837L17.318-29.151l-14.372-4.4Z"
        transform="translate(5.823 54.102)"
      />
    </g>
  </SvgIcon>
));

export default React.memo(FormationIcon);
